var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import SearchMap from "../search-map";
import StaticMap from "../listing-map-static/ListingMapStatic";
import { Container, Controls, SwitchView, SwitchViewLabel, MapLink, SubjectPropertyMarker } from "./styled/map";

function Map(_a) {
  var street = _a.street,
      city = _a.city,
      state = _a.state,
      zip = _a.zip,
      markerLat = _a.markerLat,
      markerLon = _a.markerLon,
      markerColor = _a.markerColor,
      _b = _a.backgroundColor,
      backgroundColor = _b === void 0 ? "#eeeff1" : _b,
      env = _a.env,
      casJwt = _a.casJwt,
      _c = _a.mapOptions,
      mapOptions = _c === void 0 ? {} : _c,
      mapboxApiToken = _a.mapboxApiToken,
      showSatellite = _a.showSatellite,
      setShowSatellite = _a.setShowSatellite,
      props = __rest(_a, ["street", "city", "state", "zip", "markerLat", "markerLon", "markerColor", "backgroundColor", "env", "casJwt", "mapOptions", "mapboxApiToken", "showSatellite", "setShowSatellite"]);

  var markers = [{
    id: Math.random().toString(16).substr(2),
    lat: markerLat,
    lon: markerLon,
    component: React.createElement(SubjectPropertyMarker, {
      markerColor: markerColor
    })
  }];
  var pitch = 50;
  var padding = 50;
  var zoomPadding = padding - pitch;

  var newMapOptions = __assign({
    pitch: pitch,
    container: "fullscreen-media-map-" + Math.random().toString(16).substr(2)
  }, mapOptions);

  if (showSatellite) {
    newMapOptions.style = "mapbox://styles/mapbox/satellite-v9";
  }

  return React.createElement(Container, {
    backgroundColor: backgroundColor
  }, React.createElement(SearchMap, __assign({
    markers: markers,
    boundMarkers: markers,
    zoomPadding: zoomPadding,
    isAutoZoomDisabled: true,
    isScrollZoomEnabled: true,
    isInitialZoomDisabled: true
  }, props, {
    env: env,
    casJwt: casJwt,
    mapOptions: newMapOptions,
    mapboxApiToken: mapboxApiToken
  })), React.createElement(Controls, null, React.createElement(SwitchView, {
    onClick: function onClick() {
      return setShowSatellite(function (showSatellite) {
        return !showSatellite;
      });
    }
  }, React.createElement(SwitchViewLabel, {
    showSatellite: showSatellite
  }, showSatellite ? "Streets" : "Satellite"), React.createElement(StaticMap, {
    width: 80,
    height: 80,
    latitude: markerLat,
    longitude: markerLon,
    zoomLevel: 15,
    mapboxApiToken: mapboxApiToken,
    pin: null,
    mapStyle: showSatellite ? "streets-v11" : "satellite-v9"
  })), React.createElement(MapLink, {
    href: "https://www.google.com/maps?q=" + [[street, city, state].filter(Boolean).join(", "), zip].filter(Boolean).join(" "),
    target: "_blank",
    rel: "nofollow noreferrer",
    title: "Open in Google Maps"
  }, React.createElement("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.75c-2.912 0-5.25 2.316-5.25 5.145 0 2.26 1.36 4.615 2.838 6.482A24.354 24.354 0 0010 16.99a24.369 24.369 0 002.412-2.615c1.477-1.866 2.838-4.22 2.838-6.481 0-2.83-2.338-5.145-5.25-5.145zM10 18l-.483.573-.007-.005-.015-.013a8.484 8.484 0 01-.255-.225 25.85 25.85 0 01-2.828-3.022C4.889 13.384 3.25 10.687 3.25 7.895 3.25 4.212 6.285 1.25 10 1.25s6.75 2.962 6.75 6.645c0 2.792-1.64 5.49-3.162 7.413a25.835 25.835 0 01-2.828 3.022 14.128 14.128 0 01-.255.225l-.015.013-.006.005L10 18zm0 0l.483.574a.75.75 0 01-.966 0L10 18zm0-11.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM7.25 8a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0z"
  })), React.createElement("span", null, "Open in Google Maps"))));
}

export default Map;